/* @flow */
import * as React from 'react';
import { make } from '../chunker';
import findByType from 'lib/findByType';
import ErrorReporter from 'app/components/ErrorReporter.jsx';

type Props = {
  items: *,
  children: *,
};

const GapChunk = (_props: *) => null;
const DateChunk = (_props: *) => null;
const MessageChunk = (_props: *) => null;
const PhoneCallChunk = (_props: *) => null;
const SystemMessageChunk = (_props: *) => null;

/* SequenceItemsChunker is a stream message rendered
 * that chunks stream message together, when the sender
 * is the same and the timestamps are within a a certain threhold
 *
 * The chunking let us only render a cleaner, and more compact message
 * cell if a particpant quickly sends multiple messages in a row.
 */
class SequenceItemsChunker extends React.Component<Props, void> {
  static GapChunk: *;
  static DateChunk: *;
  static MessageChunk: *;
  static PhoneCallChunk: *;
  static SystemMessageChunk: *;

  static CHUNK_TYPE_TO_CHILD_TYPE = {
    GapItem: GapChunk,
    DateSeparator: DateChunk,
    MessageItem: MessageChunk,
    PhoneCallItem: PhoneCallChunk,
    SystemMessageItem: SystemMessageChunk,
  };

  shouldComponentUpdate(nextProps: Props) {
    const newPage = this.props.items.length !== nextProps.items.length;
    const newItem = this.props.items[0].key !== nextProps.items[0].key;

    return newPage || newItem;
  }

  render() {
    if (this.props.items.length <= 0) {
      return null;
    }

    return make(this.props.items).map(chunk => {
      const childComponent = SequenceItemsChunker.CHUNK_TYPE_TO_CHILD_TYPE[chunk.type];
      const childElement = childComponent && findByType(this.props.children, childComponent);

      return childElement ? (
        childElement.props.children(chunk)
      ) : (
        <ErrorReporter
          key={chunk.key()}
          error={`could not find child for chunk of type: ${chunk.type}`}
        />
      );
    });
  }
}

SequenceItemsChunker.GapChunk = GapChunk;
SequenceItemsChunker.DateChunk = DateChunk;
SequenceItemsChunker.MessageChunk = MessageChunk;
SequenceItemsChunker.PhoneCallChunk = PhoneCallChunk;
SequenceItemsChunker.SystemMessageChunk = SystemMessageChunk;

export default SequenceItemsChunker;
